import { Box, Divider, Grid, IconButton } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import LinkIcon from "@material-ui/icons/Link";
import LinkOffIcon from "@material-ui/icons/LinkOff";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import message from "src/utils/message";

const useStyles = makeStyles(theme => ({
	root: {},
	divider: {
		display: "inline-block",
		borderLeft: `1px solid ${theme.palette.divider}`,
		height: "100%"
	}
}));
function Split(props) {
	const classes = useStyles();
	const {
		children,
		direction,
		defaultIsDivided,
		hasType,
		setCouping,
		getCouping,
		leftData,
		rightData,
		style = {},
		callback
	} = props;
	// console.log(children)
	const [isDivided, setIsDivided] = useState(
		hasType === "both" ? defaultIsDivided : true
	);
	const toggleIsDivided = () => {
		// if (defaultIsDivided) return;
		if (setCouping)
			setCouping(isDivided).then(res => {
				if (!res.isCoupled === isDivided) {
					message.error("无法耦合");
				} else {
					setIsDivided(!res.isCoupled);
					if (callback) callback(!res.isCoupled);
				}
			});
		else {
			setIsDivided(!isDivided);
			if (callback) callback(!isDivided);
		}
	};
	useEffect(() => {
		if (getCouping) {
			getCouping().then(res => {
				if (res !== null) {
					if (typeof res === "object") setIsDivided(!res.isCoupled);
					else setIsDivided(!res);
				}
			});
		}
	}, []);

	const isRow = direction === "row";

	return (
		<Grid container justify="center" style={style}>
			<Grid item md={isRow ? 5 : 12}>
				<Box mt={3}>
					<Divider />
				</Box>
				{(hasType === "right" || isDivided) && (
					<Box mt={isDivided ? 3 : 1}>
						{React.Children.map(children, child => {
							return React.cloneElement(child, {
								splittype: "right",
								splitdata: rightData
							});
						})}
					</Box>
				)}
			</Grid>
			<Grid item md={1}>
				{/* <Grid item xs={12}> */}
				<Box textAlign="center">
					<IconButton
						color="primary"
						aria-label="link"
						component="span"
						onClick={toggleIsDivided}
					>
						{/* <Fab> */}
						{isDivided ? <LinkOffIcon /> : <LinkIcon />}
						{/* </Fab> */}
					</IconButton>
				</Box>

				{/* </Grid> */}

				{isDivided && isRow && (
					<Box height="80%" mt={2} textAlign="center">
						<Box className={classes.divider}></Box>
					</Box>
				)}
			</Grid>
			<Grid item md={isRow ? 5 : 12}>
				<Box mt={3}>
					<Divider />
				</Box>
				{(isDivided || hasType === "left") && (
					<Box mt={isDivided ? 3 : 1}>
						{React.Children.map(children, child => {
							return React.cloneElement(child, {
								splittype: "left",
								splitdata: leftData
							});
						})}
					</Box>
				)}
			</Grid>
			{!isDivided && hasType === "both" && (
				<Grid item md={6}>
					<Box mt={1}>
						{React.Children.map(children, child => {
							return React.cloneElement(child, {
								splittype: "both",
								splitdata: { leftData, rightData }
							});
						})}
					</Box>
				</Grid>
			)}
		</Grid>
	);
}
Split.defaultProps = {
	direction: "row",
	defaultIsDivided: false,
	hasType: "both"
};
Split.propTypes = {
	children: PropTypes.node,
	defaultIsDivided: PropTypes.bool,
	hasType: PropTypes.string
};

export default Split;
